import {Component, OnDestroy, Renderer2, ViewChild} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {AppSidebarComponent} from './app.sidebar.component';
import {AppTopBarComponent} from './app.topbar.component';
import {AppFooterComponent} from './app.footer.component';
import {LayoutService} from './service/app.layout.service';
import {NgClass} from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-layout',
  templateUrl: './app.layout.component.html',
  imports: [
    RouterOutlet,
    AppFooterComponent,
    AppTopBarComponent,
    AppSidebarComponent,
    NgClass
  ]
})
export class AppLayoutComponent implements OnDestroy {


  @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;

  @ViewChild(AppTopBarComponent) appTopbar!: AppTopBarComponent;

  constructor(public renderer: Renderer2, public router: Router, public layoutService: LayoutService) {
  }

  ngOnDestroy() {
  }

  get containerClass() {
    return {
      'layout-slim': this.layoutService.config.menuMode === 'slim',
      'layout-static': this.layoutService.config.menuMode === 'static',
      'layout-mobile-active': this.layoutService.state.staticMenuMobileActive,
      'layout-static-inactive': this.layoutService.state.staticMenuDesktopInactive && this.layoutService.config.menuMode === 'static',
      'p-input-filled': this.layoutService.config.inputStyle === 'filled',
      'p-ripple-disabled': !this.layoutService.config.ripple,
      'layout-light': this.layoutService.config.layoutTheme === 'colorScheme' && this.layoutService.config.colorScheme === 'light',
      'layout-dark': this.layoutService.config.layoutTheme === 'colorScheme' && this.layoutService.config.colorScheme === 'dark',
      'layout-primary': this.layoutService.config.colorScheme !== 'dark' && this.layoutService.config.layoutTheme === 'primaryColor'
    };
  }

  onScroll(event: Event) {
    this.layoutService.scroll$.next(event);
  }

}

